import React from "react";
import Button from "../../../Elements/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faEye, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import CustomTooltip from "../../../Elements/Tooltip";
import { quality_data } from "../../../../hooks/utils";
import { Col, Form, Row } from "react-bootstrap";

const KDFSettingsPageListing = ({
  PdfList,
  handleUploadPDFModalStatus,
  docs,
  handleSetReplaceWith,
  handleDeletePDFEvent,
  handleUpdateDocStatus,
}) => {
  const handlePDFUpdateStatus = (e, fileID) => {
    handleUpdateDocStatus(
      { status: e.target.value, switch_active: true },
      fileID
    );
  };

  // Check if data is ready - ensure PdfList exists and is a valid array with items
  // This prevents rendering before data is loaded, avoiding empty tooltip issues
  const isDataReady = () => {
    if (!Array.isArray(PdfList) || PdfList.length === 0) {
      return false;
    }
    // Ensure at least one PDF has basic required data (title) indicating data is loaded
    // Tooltips are conditionally rendered based on their own data availability
    return PdfList.some(pdf => pdf && pdf.title);
  };

  // Don't render if data is not ready
  if (!isDataReady()) {
    return null;
  }

  return (
    <>
      <div className="Language-Editions-main">
        <div className="setting-table">
          <h5 className="text-start p-0 mb-4" >Language Editions</h5>
          <Table className="kdf-set-table">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Language</th>
                <th>Date Added / Updated</th>
                <th style={{ width: "280px" }}>Status</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {PdfList?.map((pdf, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {(() => {
                        const qualityName = quality_data().find(option => option?.value === pdf?.quality)?.name;
                        const tooltipContent = qualityName ? <p className='p-1 text-light'>{qualityName}</p> : null;
                        const content = <span className="kdf-data-center">{pdf?.title}</span>;
                        return tooltipContent ? (
                          <CustomTooltip title={tooltipContent}>
                            {content}
                          </CustomTooltip>
                        ) : content;
                      })()}
                    </td>
                    <td>
                      <span className="kdf-data-center">
                        <span
                          className={pdf?.language?.class}
                          style={{
                            height: "18px",
                            width: "25px",
                          }}
                        ></span>
                        {pdf?.language?.name ?? "English (US)"}
                      </span>
                    </td>
                    <td>
                      {pdf?.date_tooltip ? (
                        <CustomTooltip title={<p className='p-1 text-light'>{pdf?.date_tooltip}</p>}>
                          <span className="kdf-data-center">{pdf?.updated_date ?? ""}</span>
                        </CustomTooltip>
                      ) : (
                        <span className="kdf-data-center">{pdf?.updated_date ?? ""}</span>
                      )}
                    </td>
                    <td>
                      <span className="kdf-data-center">
                        {pdf?.show_switch_to_active && (
                          <span className="d-flex align-items-center justify-content-between gap-5">
                            <CustomTooltip title={<p className='p-1 text-light'>Ready for editing and sharing</p>}>
                              <select
                                id="mySelect"
                                onChange={(e) => handlePDFUpdateStatus(e, pdf.id)}
                                value={pdf.status}
                              >
                                <option value={"active"}>Ready</option>
                                <option value={"inactive"}>Edit Only</option>
                                <option value={"offline"}>Offline</option>
                              </select>
                            </CustomTooltip>
                            <u>
                              <span
                                className="setting-link ml-2"
                                onClick={() => handleSetReplaceWith(pdf.id, pdf?.language)}
                              >
                                Replace PDF
                              </span>
                            </u>
                          </span>
                        )}
                      </span>
                    </td>
                    <td>
                      <CustomTooltip title={<p className="p-1 text-light">Edit this KDF edition</p>}>
                        <span className="kdf-data-center">
                          {pdf?.show_switch_to_active && (
                            // <FontAwesomeIcon
                            //   icon={faPencil}
                            //   className=""
                            //   onClick={() => {
                            //     window.open(`/editor/${docs?.id}`, `editor-${docs?.id}`);
                            //   }}
                            // />
                            <img src="/icons/edit-blue.svg"
                            onClick={() => {
                              // Store source page for Back button label
                              sessionStorage.setItem('editorNavigationState', JSON.stringify({
                                sourcePage: 'Settings'
                              }));
                              window.open(`/editor/${docs?.id}?from=Settings`, `editor-${docs?.id}`);
                            }} />
                          )}
                        </span>
                      </CustomTooltip>
                    </td>
                    <td>
                      <CustomTooltip title={<p className="p-1 text-light">View KDF</p>}>
                        <span className="kdf-data-center">
                          {pdf?.show_switch_to_active && (
                            // <FontAwesomeIcon
                            //   icon={faEye}
                            //   onClick={() => window.open(`${pdf.viewer}`, `viewer-${pdf?.id}`)}
                            // />
                            <img src="/icons/visibility.svg" 
                              onClick={() => window.open(`${pdf.viewer}`, `viewer-${pdf?.id}`)} />
                          )}
                        </span>
                      </CustomTooltip>
                    </td>
                    <td>
                      <span className="kdf-data-center">
                        {pdf?.show_switch_to_active && (
                          // <FontAwesomeIcon
                          //   icon={faTrashCan}
                          //   className="cancel"
                          //   onClick={() => handleDeletePDFEvent(pdf.id)}
                          // />
                          <img src="/icons/delete.svg" 
                            onClick={() => handleDeletePDFEvent(pdf.id)} />
                        )}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        <Row className="justify-content-end">
          <Col md={2} className="">
            <div className="mt-1 mb-1 text-right">
              <Button
                onClick={() => handleUploadPDFModalStatus(true)}
                text={"Add Language"}
                addonClass={"rounded-0"}
                classList={'success add-language'}
              />
            </div>
          </Col>
        </Row>

      </div>
    </>
  );
};

export default KDFSettingsPageListing;
